import { render, staticRenderFns } from "./DropMenuTreeView.vue?vue&type=template&id=3bed9d08&scoped=true"
import script from "./DropMenuTreeView.vue?vue&type=script&lang=js"
export * from "./DropMenuTreeView.vue?vue&type=script&lang=js"
import style0 from "./DropMenuTreeView.vue?vue&type=style&index=0&id=3bed9d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed9d08",
  null
  
)

export default component.exports